import { useRouter } from "next/router";

export const useCurrentGroupId = (): string => {
  const router = useRouter();
  return router.query?.group_id as string;
};
